(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-bulk-bar"] && !Shopify.designMode) return;
  try {
    
  class PromoBulkBar extends HTMLElement {
    connectedCallback() {
      this.tier1 = parseInt(this.dataset.tier1Qty, 10) || 5;
      this.tier2 = parseInt(this.dataset.tier2Qty, 10) || 10;
      this.pct1 = parseInt(this.dataset.tier1Pct, 10) || 20;
      this.pct2 = parseInt(this.dataset.tier2Pct, 10) || 50;
      this.shipMin = parseFloat(this.dataset.shipMin) || 0;
      this.symbol = this.dataset.currencySymbol || '$';
      this.storageKey = 'promo-bulk-bar-dismissed';
      this.textEl = this.querySelector('[data-promo-text]');
      this.progressEl = this.querySelector('[data-promo-progress]');
      this.fillEl = this.querySelector('[data-promo-fill]');
      this.dismissed = false;
      this.lastCount = null;

      try {
        this.dismissed = sessionStorage.getItem(this.storageKey) === '1';
      } catch (e) {}

      const closeEl = this.querySelector('[data-promo-close]');
      if (closeEl) closeEl.addEventListener('click', () => this.dismiss());

      this.refresh = this.refresh.bind(this);
      ['cart:update', 'cart:refresh', 'cart:change', 'CartUpdateEvent'].forEach((evt) => {
        document.addEventListener(evt, this.refresh);
      });
      this.patchFetch();
      this.refresh();
    }

    patchFetch() {
      if (window.__promoBulkBarFetchPatched || typeof window.fetch !== 'function') return;
      window.__promoBulkBarFetchPatched = true;
      const nativeFetch = window.fetch;
      window.fetch = function (...args) {
        const input = args[0];
        const href = typeof input === 'string' ? input : input && input.url ? input.url : '';
        const result = nativeFetch.apply(this, args);
        if (href && /\/cart\/(add|change|update|clear)/.test(href)) {
          result
            .then(() => {
              setTimeout(() => document.dispatchEvent(new CustomEvent('cart:refresh')), 150);
            })
            .catch(() => {});
        }
        return result;
      };
    }

    refresh() {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((cart) => this.render(cart))
        .catch(() => this.render(null));
    }

    fill(template, values) {
      return Object.keys(values).reduce(
        (out, key) => out.replace(new RegExp('\\{' + key + '\\}', 'g'), values[key]),
        template || ''
      );
    }

    render(cart) {
      const count = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
      const total = cart && typeof cart.total_price === 'number' ? cart.total_price / 100 : 0;
      const ratio = Math.min(1, count / this.tier2);

      let message;
      let tier = 0;

      if (count >= this.tier2) {
        tier = 2;
        message = this.fill(this.dataset.msgUnlocked, { percent: this.pct2 });
      } else if (count >= this.tier1) {
        tier = 1;
        message = this.fill(this.dataset.msgTier2, {
          remaining: this.tier2 - count,
          percent: this.pct2,
          current: this.pct1,
        });
      } else if (count > 0) {
        message = this.fill(this.dataset.msgTier1, {
          remaining: this.tier1 - count,
          percent: this.pct1,
        });
      } else {
        message = this.fill(this.dataset.msgDefault, {
          tier1: this.tier1,
          tier2: this.tier2,
          percent1: this.pct1,
          percent2: this.pct2,
        });
      }

      if (this.shipMin > 0 && count > 0 && total < this.shipMin && this.dataset.msgShipping) {
        const missing = (this.shipMin - total).toFixed(2).replace(/\.00$/, '');
        message += ' ' + this.fill(this.dataset.msgShipping, { amount: this.symbol + missing });
      }

      if (this.textEl) this.textEl.innerHTML = message || '';

      // Continuous colour: the mix percentage moves with every single item.
      this.style.setProperty('--promo-ratio', Math.round(ratio * 100) + '%');
      this.dataset.tier = String(tier);
      this.dataset.count = String(count);
      this.dataset.bright = ratio >= 0.7 ? 'true' : 'false';

      // Bump and sweep on every add, not only when a tier is crossed.
      if (this.lastCount !== null && count > this.lastCount) {
        this.classList.remove('is-bumped');
        void this.offsetWidth;
        this.classList.add('is-bumped');
        setTimeout(() => this.classList.remove('is-bumped'), 1000);
      }
      this.lastCount = count;

      if (this.progressEl && this.fillEl) {
        if (count > 0 && count < this.tier2) {
          this.progressEl.hidden = false;
          this.fillEl.style.width = Math.round(ratio * 100) + '%';
        } else {
          this.progressEl.hidden = true;
        }
      }

      this.show();
    }

    show() {
      if (this.dismissed) return;
      this.hidden = false;
      requestAnimationFrame(() => this.setAttribute('data-visible', 'true'));
    }

    dismiss() {
      this.dismissed = true;
      this.removeAttribute('data-visible');
      setTimeout(() => {
        this.hidden = true;
      }, 350);
      try {
        sessionStorage.setItem(this.storageKey, '1');
      } catch (e) {}
    }
  }

  if (!customElements.get('promo-bulk-bar')) {
    customElements.define('promo-bulk-bar', PromoBulkBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quick-add-homepage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const DRAWER_SECTION = 'cart-drawer-section';

    function updateCartCounts(count) {
      document
        .querySelectorAll('.theme-drawer__badge, .cart-bubble__text, .cart-bubble__count, [data-cart-count]')
        .forEach((node) => {
          node.textContent = count;
          node.classList.toggle('visually-hidden', count === 0);
        });
    }

    /**
     * Re-renders just the cart drawer so its line items, totals and the tiered
     * progress gauge reflect the new cart. Leaves every other section alone.
     */
    function refreshCartDrawer() {
      const container = document.getElementById('shopify-section-' + DRAWER_SECTION);
      if (!container) return Promise.resolve();

      const previousDrawer = container.querySelector('theme-drawer#cart-drawer');
      const wasOpen = Boolean(
        previousDrawer && (previousDrawer.hasAttribute('open') || previousDrawer.isOpen === true)
      );

      return fetch(ROOT + '?sections=' + DRAWER_SECTION, { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : null))
        .then((sections) => {
          const markup = sections && sections[DRAWER_SECTION];
          if (!markup) return;

          const parsed = new DOMParser().parseFromString(markup, 'text/html');
          const fresh = parsed.getElementById('shopify-section-' + DRAWER_SECTION) || parsed.body;

          container.innerHTML = fresh.innerHTML;

          if (!wasOpen) return;

          // The swap destroyed the dialog that was on screen. Give the new
          // <theme-drawer> a frame to upgrade, then reopen it so the customer
          // does not end up staring at a blank panel.
          requestAnimationFrame(() => {
            const drawer = container.querySelector('theme-drawer#cart-drawer');
            if (!drawer) return;
            customElements.whenDefined('theme-drawer').then(() => {
              if (typeof drawer.open === 'function' && !drawer.isOpen) drawer.open();
            });
          });
        })
        .catch(() => {});
    }

    function ensurePromoBarVisible() {
      document.querySelectorAll('promo-bulk-bar').forEach((bar) => {
        bar.hidden = false;
        requestAnimationFrame(() => bar.setAttribute('data-visible', 'true'));
      });
    }

    function flash(button, state, label) {
      if (!button) return;
      button.dataset.quickAddState = state;
      if (label != null) button.textContent = label;
    }

    document.addEventListener(
      'submit',
      function (event) {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.closest('.pin-home')) return;
        if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;

        event.preventDefault();

        const button = form.querySelector('button[type="submit"], button[name="add"]');
        const original = button ? button.textContent : '';

        flash(button, 'loading', 'Adding');

        fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        })
          .then((response) => {
            if (!response.ok) throw new Error('add failed');
            return response.json();
          })
          .then(() => fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }))
          .then((response) => (response.ok ? response.json() : null))
          .then((cart) => {
            if (cart && typeof cart.item_count === 'number') updateCartCounts(cart.item_count);

            document.dispatchEvent(new CustomEvent('cart:refresh'));
            ensurePromoBarVisible();

            flash(button, 'done', 'Added');
            setTimeout(() => flash(button, '', original), 1400);

            return refreshCartDrawer();
          })
          .then(ensurePromoBarVisible)
          .catch(() => {
            // Fall back to the normal navigation so the customer is never stuck.
            flash(button, '', original);
            form.submit();
          });
      },
      true
    );

    /**
     * The drawer can also be opened without an add happening on this page, and the
     * markup it was rendered with may date from an older cart state. Refresh it
     * just before it opens — while it is still closed, so no dialog is destroyed.
     */
    document.addEventListener(
      'click',
      function (event) {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        if (!target.closest('cart-icon, .cart-bubble, [href$="/cart"], [on\\:click*="cart-drawer"]')) return;

        const drawer = document.querySelector('theme-drawer#cart-drawer');
        if (drawer && (drawer.hasAttribute('open') || drawer.isOpen === true)) return;

        refreshCartDrawer();
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
